import React, {useState} from 'react';
import {Button, Modal, Spinner} from "@tag/tag-components-react-v4";
import {CustomerDTO} from "../types/CustomerDTO";
import CustomerService from "../services/CustomerService";
import HelperMethods from "../../General/services/HelperMethods";
import styles from './DataExportModal.module.scss';

function DataExportModal(props: { visible: boolean, selectedCustomer: CustomerDTO, handleClose: Function, setAlert: Function, handleCustomerMenuModalClose: Function }) {

    const [loading, setLoading] = useState<string|undefined>('');
    const delay = (ms:number) => new Promise(res => setTimeout(res, ms));
    const handleMainDataExport = async () => {
        setLoading('Downloading...');
        let filename = '';

        try {
            const generateResponse = await CustomerService.generateMainDataExport(props.selectedCustomer.clientId);
            const taskId = generateResponse.taskId;

            let status;
            do {
                status = await CustomerService.getMainDataExportStatus(taskId);
                setLoading(status.progress + '%' + (status.secondaryProgress ? ' - ' + status.secondaryProgress : ''));
                await delay(500);
            } while (!status.complete);

            if (status.errorMessage) {
                props.setAlert({type: 'error', message: status.errorMessage});
                props.handleClose();
                props.handleCustomerMenuModalClose();
            }
            else {
                filename = status.result.fileDownloadName;
                HelperMethods.createDownloadableItemForClient(status.result.fileContents, filename);
            }
            setLoading(undefined);
        } catch (e) {
            setLoading(undefined);
            props.setAlert({type: 'error', message: 'An error has occured with the data export, please contact HSC Care DevOps'});
            props.handleClose();
            props.handleCustomerMenuModalClose();
        }
    }

    const handleExternalDataExport = async () => {
        setLoading('Downloading...');
        let filename = '';
        
        try {
            const generateResponse = await CustomerService.generateExternalDataExport(props.selectedCustomer.clientId);
            const taskId = generateResponse.taskId;

            let status;
            do {
                status = await CustomerService.getExternalDataExportStatus(taskId);
                setLoading(status.progress + '%' + (status.secondaryProgress ? ' - ' + status.secondaryProgress : ''));
                await delay(500);
            } while (!status.complete);

            if (status.errorMessage) {
                props.setAlert({type: 'error', message: status.errorMessage});
                props.handleClose();
                props.handleCustomerMenuModalClose();
            }
            else {
                filename = status.result.fileDownloadName;
                HelperMethods.createDownloadableItemForClient(status.result.fileContents, filename);
            }
            setLoading(undefined);
        } catch (e) {
            setLoading(undefined);
            props.setAlert({type: 'error', message: 'An error has occured with the data export, please contact HSC Care DevOps'});
            props.handleClose();
            props.handleCustomerMenuModalClose();
        }
    }

    const renderModalContent = () => {
        let modalContent;
        
        if (loading) {
            modalContent = (
                <div className={styles.DataExportModalLoaderContainer}>
                    <Spinner>{loading}</Spinner>
                </div>
            )
        } else {
            modalContent = (
                <div className={styles.DataExportModalButtonContainer}>
                    <div className={styles.DataExportModalButtonElement}>
                        <Button
                            text={'Main'}
                            onClick={() => handleMainDataExport()}
                        />
                    </div>
                    <div className={styles.DataExportModalButtonElement}>
                        <Button
                            text={'External'}
                            onClick={() => handleExternalDataExport()}
                        />
                    </div>
                </div>
            )
        }

        return modalContent;
    }

    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent='teal'
            heading={'Data Export'}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
            primaryButtonProps={{buttonStyle: {'display': 'none'}}}
        >
            <div>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
        </>
    )

}

export default DataExportModal;
